import React, { Fragment } from 'react';
import ProfileDetailsHeaderView from '../../../components/front_office/cu_profile_details/ProfileDetailsHeaderView';

const FrontConsumerProfileDetailsView = () => {
  return (
    <Fragment>
        <ProfileDetailsHeaderView />
    </Fragment>
  )
}

export default FrontConsumerProfileDetailsView